import React from 'react';
import { AdLabel } from '../../banners-carousel/components';
import { useMediaQuery } from 'fronton-react';
import { AdLabelControllerProps } from '../types';

export function AdLabelController(props: Readonly<AdLabelControllerProps>) {
  const { ord, toggleModal } = props;

  const isMobileView = useMediaQuery('(max-width: 390px)') || false;

  const toggleModalFn = () => {
    if (!isMobileView) return;
    toggleModal();
  };

  if (!ord) return null;

  return (
    <AdLabel
      {...{ ord }}
      variant="stretch-banner-text"
      toggleModal={toggleModalFn}
      isMobileView={isMobileView}
    />
  );
}
